<span [ngClass]="{'p-float-label' : isShowFloatLabel}">
    <p-calendar #pcalendar [id]="id || placeholder" styleClass="form-control-date-picker" [name]="name"
        [hourFormat]="hourFormat" [timeOnly]="timeOnly" [showSeconds]="showSeconds" [minDate]="minDate"
        [maxDate]="maxDate" [dateFormat]="calendarType==='month'?'mm/yy':displayDateFormat" [view]="calendarType" [readonlyInput]="selectableOnly"
        [icon]="icon" [showIcon]="!value" [ngModel]="value" (ngModelChange)="updateValue($event)"
        (onSelect)="selectedDate.emit($event);" (onBlur)="onTouch();" [appendTo]="appendTo" [showClear]="showClear"
        [disabled]="disabled" [placeholder]="isShowFloatLabel ? '' : placeholder" [selectionMode]="selectionMode">
    </p-calendar>
    <label *ngIf="isShowFloatLabel" [for]="id || placeholder">{{placeholder}}</label>
</span>